export const appName = "Head Spa NA POHODU";
